import React from 'react';
import '../../../styles/dashboard/Announcements.css';
import tableData from './fakeData';
import * as Svg from '../../common/icons';

const PastAnnouncements = () => {
  return (
    <table className='table-announcement'>
      <thead className='thead'>
        <tr>
          <th scope='col'></th>
          <th scope='col'>Department</th>
          <th scope='col'>Created By</th>
          <th scope='col'>Due Date</th>
          <th scope='col'></th>
          <th scope='col'></th>
          <th scope='col'></th>
          <th scope='col'></th>
        </tr>
      </thead>
      {tableData.length > 0 ? (
        <tbody>
          {tableData.map((data, id) => {
            return (
              <tr key={id}>
                <td>{data.title}</td>
                <td>{data.dept}</td>
                <td>{data.createdBY}</td>
                <td>{data.dueDate}</td>
                <td className='p-0 text-right'>
                  <Svg.Repeat />
                </td>
                <td className='p-0 text-center'>
                  <Svg.Comment />
                </td>
                <td className='p-0 text-left'>
                  <Svg.Lock />
                </td>
                <td className='p-0 text-right'>
                  <button>Read</button>
                </td>
              </tr>
            );
          })}
        </tbody>
      ) : (
        <tbody>
          <p className='loading'>Loading Data...</p>
        </tbody>
      )}
    </table>
  );
};

export default PastAnnouncements;
